const locationKey = value => String(value ?? '').trim().toUpperCase();
const packKey = row => {
  const barcodes = Array.isArray(row.barcode) ? row.barcode : [row.barcode];
  return String(row.product_barcode_id || row.catalogProductBarcodeId || row.mk_barcode ||
    barcodes.filter(Boolean).sort()[0] || `${row.quantity}:${String(row.units || '').toUpperCase()}`);
};

export const orderOutletFinancials = (financials = [], location) => {
  const outlet = locationKey(location);
  if (!outlet) return [];
  const scoped = new Set(financials.filter(row => locationKey(row.location)).map(packKey));
  return financials.filter(row => locationKey(row.location)
    ? locationKey(row.location) === outlet
    : !scoped.has(packKey(row)));
};
